import { apiGenerator, getCookie } from "../helpers/Helpers";

const token = getCookie("token"); // GET TOKEN FROM COOKIE
// export const BASE_URL = "http://128.199.22.102:8848/api"; // BASE URL
// export const FILE_URL = "http://128.199.22.102:8848/docs/"; // BASE FILE URL

//ARSP URL
export const BASE_URL = "http://202.45.145.78:8081/api"; // BASE URL
export const FILE_URL = "http://202.45.145.78:8081/docs/"; // BASE FILE URL

// export const BASE_URL = "http://192.168.1.75:8848/api"; // BASE URL
// export const FILE_URL = "http://192.168.1.75:8848/docs/"; // BASE FILE URL

// API FUNCTION
export const api = apiGenerator({ token, baseURL: BASE_URL });

// API PATHS
export const APIS = {
  sample: "/sample",
  common: "/common",
  news: "/common/type?name=news&limit=1000",
  media: "/common/type?name=media&limit=1000",
  contact: "/common/type?name=contact",
  team: "/team/type?name=team&limit=1000",
  publication: "/common/type?name=publications&limit=1000",
  newsletter: "/common/type?name=newsletter&limit=1000",
  event: "/common/type?name=events&limit=1000",
  category: "/category",
  selectedCategory: "/common/type?name=research&limit=1000&order=1",
  partner: "/team/type?name=partner&limit=1000",
  vacancy: "/common/type?name=vacancy",
  researchArticles: "/common/type?name=research-article&limit=1000&page=1",
  books: "/common/type?name=books",
  booklet: "/common/type?name=booklet",
  annualReport: "/common/type?name=annual-report",
  press: "/common/type?name=press-release",
  photoGallery: "/common/type?name=photo&limit=1000",
  videoGallery: "/common/type?name=video&limit=1000",

  otherteam: "/team/type?name=staff&limit=1000",
  directors: "/team/type?name=director&limit=1000",
  list_station_chief: "/team/type?name=station-chief-list&limit=1000",

  farmer: "/common/type?name=farmer-corner",
  office_time: "/common/type?name=office-time",
  station_chief: "/common/type?name=station-chief",
  citizen_charter: "/common/type?name=citizen-charter",
  current_research: "/common/type?name=current-research",
};
